import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'

import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import DialogTitle from '@material-ui/core/DialogTitle'
import Fab from '@material-ui/core/Fab'
import { MDAdd } from 'react-icons/md'
import Loading from '../Shared/Loading'

import { RiArrowGoBackLine } from 'react-icons/ri'
import unitTypes from '../../_constants/unitTypes'
import taskOperationTypes from '../../_constants/taskOperationTypes'
import userTypes from '../../_constants/userTypes'
import { tasksService } from '../../_services/tasks.service'
import { taskOperationsService } from '../../_services/taskOperations.service'
// import OperationIcon from '../Shared/OperationIcon'
import { FaUserAlt } from 'react-icons/fa'
import { BsFillCalendarFill } from 'react-icons/bs'
import { FiClock } from 'react-icons/fi'
import { FcProcess } from 'react-icons/fc'
import moment from 'moment-jalaali'
import MeasurementTypeDoubleBox from '../Shared/MeasurementTypeDoubleBox'
import TaskCode from '../Shared/TaskCode'
import { AiOutlineLoading } from 'react-icons/ai'
import { MdClose } from 'react-icons/md'

import { VerticalTimeline, VerticalTimelineElement } from '../Shared/timeline'

import ChangeProductsModal from './SPrum/ChangeProductsModal'
import { GiCardExchange } from 'react-icons/gi'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const TaskReportModal = props => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(undefined)
  const [showModal, setShowModal] = useState(props.show)

  const [changeProductsModalShow, setChangeProductsModalShow] = useState(false)
  const [productItem, setProductItem] = useState({})

  // const hamdleChangeProductClick = item => {
  //   // console.log(item);
  //   // console.log(values.previousInputs);

  //   // let remainingQuantity = 0

  //   // if (values.previousInputs) {

  //   //   let previousInputs = values.previousInputs.filter(el => el.product.id === item.product.id)

  //   //   if (previousInputs) {
  //   //     let usedQuantity = 0;

  //   //     previousInputs.forEach(p => {
  //   //       usedQuantity += p.quantity
  //   //     });
  //   //     console.log(usedQuantity);

  //   //   }

  //   // }

  //   // setProductItem(item)
  //   setChangeProductsModalShow(true)
  // }

  useEffect(() => {
    if (props.show) {
      getData()
    } else {
      setData(undefined)
    }
    setShowModal(props.show)
  }, [props.show])

  const getData = () => {
    setLoading(true)

    if (props.taskId) {
      tasksService
        .getReportByTaskId(props.taskId)
        .then(res => {
          let result = res.data

          let arr = []

          unitTypes.forEach(item => {
            let newArr = result.taskOperations.filter(
              el => el.unitType === item.value
            )
            newArr.length > 0 &&
              arr.push({
                unitType: item.label,
                unitTypeId: item.value,
                taskOperations: newArr
              })
          })

          result['taskOperations'] = arr

          setData(result)

          console.log(res)

          setLoading(false)
        })
        .catch(err => {
          console.log(err)

          setLoading(false)
        })
    }
  }

  const handleCloseModal = () => {
    props.onClose(false)
  }

  return (
    <React.Fragment>
      <ChangeProductsModal
        taskId={data && data.taskId}
        item={productItem}
        show={changeProductsModalShow}
        onClose={() => setChangeProductsModalShow(false)}
      />
      <Dialog
        open={showModal}
        onClose={() => handleCloseModal()}
        TransitionComponent={Transition}
        scroll={'paper'}
        fullScreen={true}>
        <DialogTitle>
          <Fab
            color="secondary"
            aria-label="refresh"
            size="small"
            onClick={() => handleCloseModal()}
            className="modal-close-btn">
            <MdClose size="20px" />
          </Fab>
          <span style={{ marginRight: 10 }} />
        </DialogTitle>
        <DialogContent dividers={true} className="modal-gray-bg">
          <ReportDetails
            data={data}
            loading={loading}
            forceRelaod={() => getData()}
            user={props.user}
          />
        </DialogContent>
      </Dialog>
    </React.Fragment>
  )
}

// export default TaskReportModal

function mapStateToProps(state) {
  const { authentication } = state
  const { user } = authentication
  return {
    user
  }
}
const connectedTaskReportModal = connect(mapStateToProps)(TaskReportModal)
export default connect(
  mapStateToProps,
  null
)(TaskReportModal)

// export { connectedTaskReportModal as TaskReportModal }

const ReportDetails = ({ loading, data, forceRelaod, user }) => (
  <React.Fragment>
    {!loading && data ? (
      <>
        <table className="table validator-table" style={{ marginBottom: 5 }}>
          <thead>
            <tr>
              <th className="text-center">ردیف</th>
              <th className="text-center">کد سفارش</th>
              <th className="text-center">دسته بندی</th>
              <th className="text-center">برند</th>
              <th className="text-center">نام کالا</th>
              <th className="text-center">کد کالا</th>
              <th className="text-center">میزان سفارش</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>
                <TaskCode code={data.task.taskCode} />
              </td>
              <td>
                {data.task.product &&
                  data.task.product &&
                  data.task.product.category.name}
              </td>

              <td>
                {data.task.product &&
                  data.task.product &&
                  data.task.product.brand.name}
              </td>
              <td>
                {data.task.product &&
                  data.task.product &&
                  data.task.product.name}
              </td>
              <td>
                {data.task.product &&
                  data.task.product &&
                  data.task.product.extraCode}
              </td>
              <td>
                {data.task.product && (
                  <MeasurementTypeDoubleBox
                    product={data.task.product}
                    value={data.task.quantity}
                    onlySub={
                      data.task.product.subMeasurementType !== undefined
                        ? true
                        : false
                    }
                  />
                )}
              </td>
            </tr>
          </tbody>
        </table>
        <VerticalTimeline title={data.task && data.task.taskCode}>
          {data &&
            data.taskOperations &&
            data.taskOperations.map((item, index) => (
              <TaskOperationItem
                data={item}
                isLastItem={
                  data.taskOperations.length === index + 1 && index > 0
                }
                forceRelaod={() => forceRelaod()}
                user={user}
              />
            ))}
        </VerticalTimeline>
      </>
    ) : (
      <Loading />
    )}
  </React.Fragment>
)

const TaskOperationItem = props => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(props.data)
  const [activeItem, setActiveItem] = useState(undefined)
  const [itemsInitialValues, setItemsInitialValues] = useState(undefined)

  useEffect(() => {
    if (props.data && data.taskOperations) {
      let allData = props.data.taskOperations
      let taskOperation = allData.filter(el => el.unitType === 1)
      let values = []
      if (taskOperation && taskOperation[0]) {
        values = taskOperation[0].taskOperationProducts
        setItemsInitialValues(values)
        // console.log(values);
      }
    }

    setData(props.data)
    // console.log(props.data);
  }, [props.data])

  const handleClickItem = itemId => {
    if (itemId !== activeItem) {
      setActiveItem(itemId)
    } else {
      setActiveItem(undefined)
    }
  }

  const handleBackwardOperation = taskOperationId => {
    setLoading(true)

    taskOperationsService
      .backwardOperation(taskOperationId)
      .then(res => {
        let result = res.data

        console.log(result)

        props.forceRelaod()

        setLoading(false)
      })
      .catch(err => {
        console.log(err)

        setLoading(false)
      })
  }

  return (
    <React.Fragment>
      <VerticalTimelineElement unitType={data && data.unitType}>
        {data.taskOperations?.map((item, index) => (
          <div class="row" key={'taskOperation-' + index}>
            <div class="col-sm-12">
              <div class="timeline-box">
                <div
                  class="box-title pointer"
                  onClick={() => handleClickItem(item.id)}>
                  <FcProcess size="20px" color="#fff" />{' '}
                  {
                    taskOperationTypes.filter(
                      el => el.value === item.taskOperationType
                    )[0].label
                  }
                  {[7, 8, 9, 12, 13, 16, 17, 18, 22, 23, 24, 25, 26].includes(
                    item.taskOperationType
                  ) && ' (' + item.affectedUnitName + ')'}
                  {data.taskOperations.length === index + 1 &&
                    props.isLastItem &&
                    (props.user && props.user.userType !== 3) && (
                      <a
                        onClick={e => {
                          e.stopPropagation()
                          handleBackwardOperation(item.id)
                        }}
                        className="btn btn-primary pull-left btn-sm"
                        disabled={loading}
                        style={{ margin: 0 }}>
                        {loading ? (
                          <AiOutlineLoading
                            size="16px"
                            className="mdi mdi-48px mdi-spin mdi-loading"
                          />
                        ) : (
                          <RiArrowGoBackLine size="16px" />
                        )}
                        &nbsp;بازگشت عملیات
                      </a>
                    )}
                </div>
                <div
                  class={
                    activeItem === item.id
                      ? 'box-content active'
                      : 'box-content'
                  }>
                  <TaskProducts
                    data={item}
                    taskOperationProductType={0}
                    itemsInitialValues={itemsInitialValues}
                    onSubmit={() => props.forceRelaod()}
                  />
                  {item.taskOperationType !== 7 && (
                    <TaskProducts
                      data={item}
                      taskOperationProductType={1}
                      onSubmit={() => props.forceRelaod()}
                    />
                  )}

                  <TaskOperationInfos data={item?.taskOperationInfos} />

                  <TaskOperationPersonnels data={item} />

                  {item.description ? (
                    <fieldset className="fieldset">
                      <legend>توضیحات</legend>
                      <pre>{item.description}</pre>
                    </fieldset>
                  ) : (
                    ''
                  )}
                </div>
                <div
                  class="box-footer pointer"
                  onClick={() => handleClickItem(item.id)}>
                  <div className="right">
                    <FaUserAlt />{' '}
                    {item.userType
                      ? userTypes.filter(el => el.value === item.userType)[0]
                          .label +
                        (item.userFullName && ' (' + item.userFullName + ')')
                      : ''}
                  </div>
                  <div className="left">
                    {moment(item.createdAt, 'YYYY/M/D H:m').format('H:mm')}{' '}
                    <FiClock color="#fff" size="20px" />{' '}
                    {moment(item.createdAt, 'YYYY/M/D H:m').format(
                      'jYYYY/jM/jD'
                    )}{' '}
                    <BsFillCalendarFill />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </VerticalTimelineElement>
    </React.Fragment>
  )
}

const TaskProducts = props => {
  const [data, setData] = useState(props.data)
  const [changeProductsModalShow, setChangeProductsModalShow] = useState(false)
  const [productItem, setProductItem] = useState({})

  useEffect(() => {
    let filteredData = props.data.taskOperationProducts.filter(
      el => el.taskOperationProductType === props.taskOperationProductType
    )

    setData(filteredData)
    console.log(props.data)
    // console.log(props.data.unitType, props.data.taskOperationType, props.taskOperationProductType);
  }, [props.data])

  const hamdleChangeProductClick = item => {
    // console.log(item);
    // console.log(data);
    // console.log(data.previousInputs);

    // let remainingQuantity = 0

    // if (values.previousInputs) {

    //   let previousInputs = values.previousInputs.filter(el => el.product.id === item.product.id)

    //   if (previousInputs) {
    //     let usedQuantity = 0;

    //     previousInputs.forEach(p => {
    //       usedQuantity += p.quantity
    //     });
    //     console.log(usedQuantity);

    //   }

    // }

    setProductItem(item)
    setChangeProductsModalShow(true)
  }

  return (
    data &&
    data.length > 0 && (
      <React.Fragment>
        <ChangeProductsModal
          itemsInitialValues={props.itemsInitialValues}
          taskId={data.taskId}
          item={productItem}
          show={changeProductsModalShow}
          onSubmit={() => props.onSubmit()}
          onClose={() => setChangeProductsModalShow(false)}
        />
        <fieldset className="fieldset">
          <legend>
            {props.taskOperationProductType === 0
              ? 'مواد اولیه'
              : 'کالای تولید شده'}
          </legend>
          <table className="table validator-table" style={{ marginBottom: 5 }}>
            <thead>
              <tr>
                <th className="text-center">ردیف</th>
                {props.taskOperationProductType === 0 &&
                  props.data.taskOperationType === 26 &&
                  props.data.taskStatus === 1 && (
                    <th className="text-center">جایگزینی مواد اولیه</th>
                  )}
                <th className="text-center">دسته بندی</th>
                <th className="text-center">برند</th>
                <th className="text-center">نام کالا</th>
                <th className="text-center">کد کالا</th>
                {props.data.unitType !== 0 &&
                (props.data.taskOperationType === 8
                  ? props.taskOperationProductType !== 0
                  : true) &&
                (props.data.taskOperationType === 12
                  ? props.taskOperationProductType !== 0
                  : true) &&
                (props.data.taskOperationType === 22
                  ? props.taskOperationProductType !== 0
                  : true) &&
                (props.data.taskOperationType === 16 ? true : true) &&
                (props.data.taskOperationType === 24 ? true : true) &&
                (props.data.taskOperationType === 26
                  ? props.taskOperationProductType !== 0
                  : true) ? (
                  <th className="text-center">
                    {props.taskOperationProductType === 0
                      ? props.data.taskOperationType === 12 ||
                        props.data.taskOperationType === 23
                        ? 'تعداد کل ورق بکار رفته'
                        : props.data.taskOperationType === 16 ||
                          props.data.taskOperationType === 24 ||
                          props.data.taskOperationType === 26
                        ? 'مقدار استفاده شده سالم'
                        : 'مقدار اولیه'
                      : 'مقدار تولید شده'}
                  </th>
                ) : (
                  ''
                )}

                {props.data.taskStatus === -1 &&
                props.data.taskOperationType === 0 ? (
                  <th>مقدار رزرو شده</th>
                ) : (
                  ''
                )}

                {(props.taskOperationProductType === 0 &&
                  props.data.taskOperationType === 8) ||
                (props.taskOperationProductType === 0 &&
                  props.data.taskOperationType === 20) ||
                (props.taskOperationProductType === 0 &&
                  props.data.taskOperationType === 22) ||
                props.data.taskOperationType === 12 ||
                props.data.taskOperationType === 23 ||
                (props.taskOperationProductType === 0 &&
                  props.data.taskOperationType === 16) ||
                (props.taskOperationProductType === 0 &&
                  props.data.taskOperationType === 24) ||
                (props.taskOperationProductType === 0 &&
                  props.data.taskOperationType === 26) ? (
                  <th className="text-center">
                    {props.data.taskOperationType === 12 ||
                    props.data.taskOperationType === 23
                      ? props.taskOperationProductType === 0
                        ? 'تعداد ضایعات از ورق های بکار رفته'
                        : 'ضایعات تایل'
                      : 'ضایعات'}
                  </th>
                ) : (
                  ''
                )}

                {(props.taskOperationProductType === 0 &&
                  props.data.taskOperationType === 8) ||
                (props.taskOperationProductType === 0 &&
                  props.data.taskOperationType === 20) ||
                (props.taskOperationProductType === 0 &&
                  props.data.taskOperationType === 22) ||
                (props.taskOperationProductType === 0 &&
                  props.data.taskOperationType === 26) ||
                props.data.taskOperationType === 19 ? (
                  <th className="text-center">
                    {props.data.taskOperationType === 19
                      ? 'مغایرت'
                      : 'مصرف اضافی'}
                  </th>
                ) : (
                  ''
                )}
              </tr>
            </thead>
            <tbody>
              {data &&
                data.map((item, index) => (
                  <tr key={'p-' + index}>
                    <td>{index + 1}</td>
                    {props.taskOperationProductType === 0 &&
                      props.data.taskOperationType === 26 &&
                      props.data.taskStatus === 1 && (
                        <td>
                          <a onClick={() => hamdleChangeProductClick(item)}>
                            <GiCardExchange size="24px" color="#F44336" />
                          </a>
                        </td>
                      )}
                    <td>{item.product && item.product.category.name}</td>
                    <td>{item.product && item.product.brand.name}</td>
                    <td>{item.product && item.product.name}</td>
                    <td>{item.product && item.product.extraCode}</td>
                    {props.data.unitType !== 0 &&
                    (props.data.taskOperationType === 8
                      ? props.taskOperationProductType !== 0
                      : true) &&
                    (props.data.taskOperationType === 16 ? true : true) &&
                    (props.data.taskOperationType === 22
                      ? props.taskOperationProductType !== 0
                      : true) &&
                    (props.data.taskOperationType === 24 ? true : true) &&
                    (props.data.taskOperationType === 26
                      ? props.taskOperationProductType !== 0
                      : true) ? (
                      <td>
                        {item.product !== undefined ? (
                          <div className="flex-col flex-center">
                            <MeasurementTypeDoubleBox
                              product={item.product}
                              value={item.quantity}
                              onlySub={
                                item.subQuantity !== undefined &&
                                item.quantity !== item.subQuantity &&
                                (props.data.taskOperationType !== 16 &&
                                  props.data.taskOperationType !== 24)
                                  ? true
                                  : false
                              }
                            />
                          </div>
                        ) : (
                          ''
                        )}
                      </td>
                    ) : (
                      ''
                    )}

                    {props.data.taskStatus === -1 &&
                      props.data.taskOperationType === 0 && (
                        <td>
                          {item.product !== undefined ? (
                            <div className="flex-col flex-center">
                              <MeasurementTypeDoubleBox
                                product={item.product}
                                value={item.quantity}
                                // onlySub={
                                //   // item.subQuantity !== undefined &&
                                //   item.quantity !== item.subQuantity &&
                                //   props.data.taskStatus === -1 &&
                                //   props.data.taskOperationType === 0
                                //     ? true
                                //     : false
                                // }
                              />
                            </div>
                          ) : (
                            ''
                          )}
                        </td>
                      )}

                    {(props.taskOperationProductType === 0 &&
                      props.data.taskOperationType === 8) ||
                    (props.taskOperationProductType === 0 &&
                      props.data.taskOperationType === 20) ||
                    (props.taskOperationProductType === 0 &&
                      props.data.taskOperationType === 22) ||
                    props.data.taskOperationType === 12 ||
                    props.data.taskOperationType === 23 ||
                    (props.taskOperationProductType === 0 &&
                      props.data.taskOperationType === 16) ||
                    (props.taskOperationProductType === 0 &&
                      props.data.taskOperationType === 24) ||
                    (props.taskOperationProductType === 0 &&
                      props.data.taskOperationType === 26) ? (
                      <td>
                        {item.product !== undefined && (
                          <div className="flex-col flex-center">
                            <MeasurementTypeDoubleBox
                              product={item.product}
                              value={item.waste}
                              onlySub={
                                item.subWaste !== undefined &&
                                item.waste !== item.subWaste
                                  ? true
                                  : false
                              }
                            />
                          </div>
                        )}
                      </td>
                    ) : (
                      ''
                    )}

                    {(props.taskOperationProductType === 0 &&
                      props.data.taskOperationType === 8) ||
                    (props.taskOperationProductType === 0 &&
                      props.data.taskOperationType === 20) ||
                    (props.taskOperationProductType === 0 &&
                      props.data.taskOperationType === 22) ||
                    (props.taskOperationProductType === 0 &&
                      props.data.taskOperationType === 26) ||
                    props.data.taskOperationType === 19 ? (
                      <td>
                        {item.product !== undefined && (
                          <div className="flex-col flex-center">
                            <MeasurementTypeDoubleBox
                              product={item.product}
                              value={item.extraQuantity}
                              onlySub={
                                item.subExtraQuantity !== undefined &&
                                item.extraQuantity !== item.subExtraQuantity
                                  ? true
                                  : false
                              }
                            />
                          </div>
                        )}
                      </td>
                    ) : (
                      ''
                    )}
                  </tr>
                ))}
            </tbody>
          </table>
        </fieldset>
      </React.Fragment>
    )
  )
}

const TaskOperationPersonnels = props => {
  const [data, setData] = useState(props.data)

  useEffect(() => {
    let filteredData = props.data.taskOperationPersonnels

    setData(filteredData)
    // console.log(filteredData);
  }, [props.data])

  return (
    data &&
    data.length > 0 && (
      <React.Fragment>
        <fieldset className="fieldset">
          <legend>اطلاعات پرسنل</legend>

          <table className="table validator-table" style={{ marginBottom: 5 }}>
            <thead>
              <tr>
                <th className="text-center">شیفت</th>
                <th className="text-center">سرشیفت</th>
                <th className="text-center">مسئول پرس</th>
                <th className="text-center">کنترل کیفی</th>
                <th className="text-center">اپراتورها</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div className="shift">{props.data.shift}</div>
                </td>
                <td>
                  {
                    data.filter(e => e.taskOperationPersonnelType === 1)[0]
                      .fullName
                  }
                </td>
                <td>
                  {
                    data.filter(e => e.taskOperationPersonnelType === 2)[0]
                      .fullName
                  }
                </td>
                <td>
                  {
                    data.filter(e => e.taskOperationPersonnelType === 4)[0]
                      .fullName
                  }
                </td>
                <td>
                  {data
                    .filter(e => e.taskOperationPersonnelType === 0)
                    .map(
                      (item, index) =>
                        item.fullName +
                        (data.filter(e => e.taskOperationPersonnelType === 0)
                          .length -
                          1 !==
                        index
                          ? ' - '
                          : '')
                    )}
                </td>
              </tr>
            </tbody>
          </table>
        </fieldset>
      </React.Fragment>
    )
  )
}

const TaskOperationInfos = props => {
  const [infos, setInfos] = useState([])

  useEffect(() => {
    setInfos(props.data)
    // console.log(filteredData);
  }, [props.data])

  return (
    infos?.length > 0 && (
      <fieldset className="fieldset">
        <legend>اطلاعات تکمیلی</legend>
        <table className="table validator-table" style={{ marginBottom: 5 }}>
          <thead>
            <tr>
              {infos.map((item, index) => (
                <th key={index} className="text-center">
                  {item.info?.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              {infos.map((item, index) => (
                <th key={index} className="text-center">
                  {item.info?.fieldType === 0
                    ? item.value
                    : item.info?.fieldType === 2
                    ? yesNoFields.find(e => e.value === item.value)?.text
                    : ''}
                </th>
              ))}
            </tr>
          </tbody>
        </table>
      </fieldset>
    )
  )
}

const yesNoFields = [
  { text: 'دارد', value: '1' },
  { text: 'ندارد', value: '2' }
]
